import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@leverege/ui-elements'

export default class YesNoDialog extends React.Component {
  
  static propTypes = {
    onYes : PropTypes.func,
    onNo : PropTypes.func,
    title : PropTypes.string,
    message : PropTypes.oneOfType( [ PropTypes.string, PropTypes.element ] ),
    yes : PropTypes.string,
    no : PropTypes.string
  }

  static defaultProps = {
    yes : 'Yes',
    no : 'Cancel',
    title : 'Question',
    message : 'Do you want to continue?'
  }

  constructor( props ) {
    super( props );
    this.onYes = this.onYes.bind( this );
    this.onNo = this.onNo.bind( this );
  }

  onYes() {
    if ( this.props.onYes ) {
      this.props.onYes();
    }
  }

  onNo() {
    if ( this.props.onNo ) {
      this.props.onNo();
    }
  }

  render() {
    const { yes, no, message, title, onYes, onNo, show, variant, yesVariant, ...rest } = this.props;
    // overflow visible allows combo boxes to work
    const Component = onYes ? Dialog.Question : Dialog.Message

    return (
      <Component
        variant={variant}
        okayVariant={yesVariant}
        show={show}
        title={title}
        okay={yes}
        cancel={no}
        onOkay={onYes}
        onCancel={onNo}
        onClose={onNo}
        {...rest}>
        {message}
      </Component>
    )
  }

}
